import * as React from "react";

function SvgGd6DLogoManagementMob(props) {
  const { isDisabled, ...restProps } = props

  const palette = {
    default: ['#0039cb', '#2979ff', '#263238'],
    disabled: ['#90A4AE', '#607D8B']
  }

  return (
    <svg
      id="GD6D__logo__management-mob_svg__Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 423.7 128.78"
      {...restProps}
    >
      <defs>
        <style>
          {
            `.GD6D__logo__management-mob_svg__cls-1{fill:${isDisabled ? palette.disabled[1] : palette.default[0]}}.GD6D__logo__management-mob_svg__cls-2{fill:${isDisabled ? palette.disabled[0] : palette.default[1]}}.GD6D__logo__management-mob_svg__cls-3{fill:${isDisabled ? palette.disabled[0] : palette.default[2]}}`
          }
        </style>
      </defs>
      <circle
        className="GD6D__logo__management-mob_svg__cls-1"
        cx={343.69}
        cy={43.03}
        r={10.5}
      />
      <path
        className="GD6D__logo__management-mob_svg__cls-1"
        d="M333.19 85.05a10.51 10.51 0 0015.75 9.1l3.13-1.81a21.8 21.8 0 00-18.88-32.7v25.41"
      />
      <circle
        className="GD6D__logo__management-mob_svg__cls-2"
        cx={380.06}
        cy={64.03}
        r={10.5}
      />
      <path
        className="GD6D__logo__management-mob_svg__cls-2"
        d="M348.94 94.15a10.51 10.51 0 01-15.75-9.1v-3.62a21.81 21.81 0 0137.76 0l-22 12.7"
      />
      <path
        className="GD6D__logo__management-mob_svg__cls-3"
        d="M41.94 94.37h-8.46v-34.8h9.86l9.24 18.73 9.13-18.73h9.91v34.8h-8.45V74.49L52.58 95.78 41.94 74.49zM103.6 82.58c0 7.15-6 12.73-13.62 12.73-7.82 0-13.51-5.42-13.51-13s5.58-13 13.62-13c7.83-.03 13.51 5.55 13.51 13.27zm-19.2-.26c0 3.55 2.3 6 5.64 6a5.47 5.47 0 005.58-5.84c0-3.86-2.09-6.16-5.53-6.16s-5.69 2.4-5.69 6zM116 94.37h-7.93v-34.8H116v13.05a9.29 9.29 0 017.51-3.34 12.85 12.85 0 019.08 3.81 13.13 13.13 0 013.41 9.33c0 7.78-4.85 12.89-12.21 12.89-3.55 0-5.74-1-7.77-3.55zm-.11-11.79c0 3.71 2.46 6.47 5.74 6.47 3.44 0 5.9-2.71 5.9-6.57s-2.51-6.63-5.74-6.63-5.88 3.08-5.88 6.73zM148.68 63.22A4.23 4.23 0 11144.5 59a4.05 4.05 0 014.18 4.22zm-.26 31.15h-7.93V70.22h7.93zM154.31 94.37v-34.8h7.93v34.8zM176.33 63.22a4.23 4.23 0 11-4.18-4.22 4.05 4.05 0 014.18 4.22zm-.26 31.15h-7.93V70.22h7.93zM191.93 77.36v-.47a2.1 2.1 0 00-2.3-1.93 1.7 1.7 0 00-1.87 1.62c0 1 .73 1.57 2.76 2.14 6.78 1.93 9.24 4.18 9.24 8.4 0 4.91-3.92 8.19-9.81 8.19s-9.6-3.08-9.76-8.14h7.51c.32 1.78.89 2.45 2.25 2.45a1.73 1.73 0 001.82-1.72c0-1.09-.78-1.67-4-2.71-5.27-1.67-7.57-4.12-7.57-7.93 0-4.8 3.91-8 9.76-8s9.28 3 9.34 8.08zM222.6 70.22h7.94v24.15h-7.94v-2.71a10.11 10.11 0 01-8.19 3.65c-6.88 0-11.84-5.27-11.84-12.68 0-7.72 5.27-13.35 12.52-13.35 3.08 0 5.17 1 7.51 3.54zM211 82.48c0 3.7 2.51 6.57 5.74 6.57s6-3 6-6.68c0-3.86-2.45-6.52-5.9-6.52S211 78.62 211 82.48zM245 86.23c0 1.15.42 1.46 1.93 1.57h.84v6.57h-6.07c-3.39-.1-4.64-1.51-4.59-5V76.63h-2.45v-6.57h2.45v-6H245v6h2.77v6.57H245zM260.8 63.22a4.23 4.23 0 11-4.18-4.22 4.06 4.06 0 014.18 4.22zm-.27 31.15h-7.93V70.22h7.93zM292.1 82.58c0 7.15-6 12.73-13.62 12.73-7.83 0-13.51-5.42-13.51-13s5.58-13 13.61-13c7.83-.03 13.52 5.55 13.52 13.27zm-19.2-.26c0 3.55 2.29 6 5.63 6a5.47 5.47 0 005.59-5.84c0-3.86-2.09-6.16-5.54-6.16s-5.68 2.4-5.68 6zM304.51 70.22v2.71c1.57-2.66 3.24-3.65 6.16-3.65a9 9 0 016.21 2.34c1.62 1.67 2.19 3.66 2.19 7.94v14.81h-7.93V79.61c0-2.35-1.25-3.76-3.29-3.76s-3.34 1.51-3.34 3.86v14.66h-7.93V70.22zM180.78 47.87h-3.58V33.14h4.17l3.91 7.93 3.86-7.93h4.2v14.73h-3.58v-8.41l-4.48 9-4.5-9zM199.23 45.75l-.64 2.12h-3.82l4.86-14.73h4.54L209 47.87h-3.93l-.64-2.12zm2.6-8.39l-1.72 5.5h3.45zM214 47.87h-3.6V33.14h3.6l5.37 8.28v-8.28h3.57v14.73h-3.57L214 39.48zM228.81 45.75l-.64 2.12h-3.82l4.85-14.73h4.55l4.84 14.73h-3.93l-.66-2.12zm2.6-8.39l-1.72 5.5h3.44zM254.54 39.48v.77a7.51 7.51 0 01-2.43 5.83 8.14 8.14 0 01-5.41 2.08 7.65 7.65 0 110-15.3 7.89 7.89 0 016.21 2.91l-2.72 2.1a4.05 4.05 0 00-3.37-1.7 4.17 4.17 0 00-4.15 4.39 4.29 4.29 0 004.3 4.35 3.85 3.85 0 003.69-2.54H247v-2.89zM259.4 39h4.86v2.89h-4.86v3h4.86v2.89h-8.44V33.14h8.44V36h-4.86zM270.19 47.87h-3.57V33.14h4.17l3.91 7.93 3.86-7.93h4.19v14.73h-3.57v-8.41l-4.48 9-4.51-9zM288.47 39h4.85v2.89h-4.85v3h4.85v2.89h-8.43V33.14h8.43V36h-4.85zM299.26 47.87h-3.57V33.14h3.57l5.37 8.28v-8.28h3.57v14.73h-3.57l-5.37-8.39zM316.61 47.87H313V36h-3.4v-2.9H320V36h-3.38z"
      />
    </svg>
  );
}

export default SvgGd6DLogoManagementMob;
